export default "__VITE_ASSET__rzY2UL9S__"